import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IOrderDetail } from "interfaces";
import { EditOrderSection } from "./components";
import { AddonProductSection } from "./components/detail/addonProductSection";
import { EditBuyerSection } from "./components/edit/buyerSection";
import { EditPurchasedProductSection } from "./components/edit/purchasedProductSection";
import { EditVATSection } from "./components/edit/vatSection";
import { get } from "lodash";

export const EditOrder: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
    refetch,
  } = useOne<IOrderDetail>({
    resource: "checkout/orders",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const orderDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  const rate = get(orderDetailData?.rates, "rates.VND", 0);
  
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Order" />
      <div className="box-container p-0">
        <div className="px-4 py-6 sm:px-6 flex items-center justify-between">
          <p className="font-bold text-xl">
            <span className="text-brand-secondary-500">#{orderDetailData?.code}</span>
          </p>
        </div>
      </div>
      {orderDetailData ? (
        <>
          <EditBuyerSection orderDetailData={orderDetailData} refetch={refetch} />
          <EditOrderSection orderDetailData={orderDetailData} refetch={refetch} rate={rate} />
          <AddonProductSection orderDetailData={orderDetailData} rate={rate} />
          <EditVATSection orderDetailData={orderDetailData} refetch={refetch} />
          <EditPurchasedProductSection orderDetailData={orderDetailData} rate={rate} />
        </>
      ) : (
        <></>
      )}
      {isFetching && isPreviousData ? <FullScreenLoading /> : <></>}
    </div>
  );
};
